import { db } from '../../config/firebase';

import { collection, addDoc } from 'firebase/firestore';

export const saveStripeData = async (paymentIntentId, uid, sessionId, customerStripeID) => {
  const paymentCollection = collection(db, 'payments');

  try {
    // Save the user document in the "payments" collection
    await addDoc(paymentCollection, {
      paymentStatus: false,
      paymentIntent: paymentIntentId ? paymentIntentId : '',
      sessionId: sessionId ? sessionId : '',
      donationAmount: 0,
      uid: uid ? uid : '',
      date: null,
      billingAddress: null,
      metadata: null,
      paymentDetails: null,
      invoicePdf: null,
      customerStripeID,
    });
  } catch (error) {
    console.error('Error saving user:', error);
  }
};
